<template>
  <div id="acc-levy-rates">
    <el-row>
      <el-col :span="12">
        <p>Acc Levy Rates</p>
      </el-col>
      <el-col :span="12">
        <el-button
          size="mini"
          class="right"
          type="primary"
          plain
          @click="show_dialog = true"
        >
          Add Levy Rate
        </el-button>
      </el-col>
    </el-row>
    <el-table
      :data="levy_rates"
      stripe
    >
      <el-table-column
        prop="start"
        label="Start"
        width="160"
      />
      <el-table-column
        prop="ends"
        label="End"
        width="160"
      />
      <el-table-column
        prop="rate"
        label="Rate %"
        width="160"
      />
      <el-table-column width="160">
        <template #default="scope">
          <el-button
            size="mini"
            type="danger"
            plain
            @click="delete_acc_levy_rate(scope.row.id)"
          >
            Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="New Acc Levy Rate"
      :visible.sync="show_dialog"
      width="30%"
      @opened="set_default_input()"
    >
      <el-form
        ref="acc_levy_rate"
        :model="levy_rate"
        label-width="140px"
        :rules="rules"
      >
        <el-form-item
          label="Start period"
          prop="start"
          required
        >
          <el-date-picker
            v-model="levy_rate.start"
            placeholder="Start period"
            format="dd.MM.yyyy"
            size="small"
            default-value="2025-04-01"
          />
        </el-form-item>
        <el-form-item
          label="End period"
          prop="ends"
          required
        >
          <el-date-picker
            v-model="levy_rate.ends"
            placeholder="End period"
            format="dd.MM.yyyy"
            size="small"
            default-value="2026-03-31"
            type="datetime"
          />
        </el-form-item>
        <el-form-item
          label="Rate in %"
          prop="rate"
          required
        >
          <el-input-number
            v-model="levy_rate.rate"
            size="small"
            :precision="2"
            :step="0.05"
            :max="10"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="create_acc_levy_rate"
          >
            Save
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {acc_levy_rates, create_acc_levy_rate, delete_acc_levy_rate} from '../../api/acc_levy_rates';
export default {
  name: 'AccLevyRates',
  data() {
    return {
      levy_rate: { rate: 1},
      levy_rates: [],
      show_dialog: false,
      rules: {
        rate: [{ required: true, message: ' ' }],
        start: [{ required: true, message: ' ' }],
        ends: [{ required: true, message: ' ' }],
      }
    };
  },
  created() {
    this.acc_levy_rates();
  },
  methods: {
    acc_levy_rates(){
      acc_levy_rates(this).then((response)=> {
        this.levy_rates = response.data;
      });
    },
    create_acc_levy_rate(){
      this.$refs['acc_levy_rate'].validate((valid) => {
        if (valid) {
          create_acc_levy_rate(this, this.levy_rate).then((response) => {
            this.$message({
              type: 'success',
              message: response.data.message
            });
            this.acc_levy_rates();
          });
        }
      });
    },
    delete_acc_levy_rate(id){
      delete_acc_levy_rate(this, id).then((response)=> {
        this.$message({
          type: 'success',
          message: response.data.message
        });
        this.acc_levy_rates();
      });
    },
    set_default_input() {
      Array.from(document.querySelectorAll('.el-select__input, .el-input__inner')).forEach(
        function (e) {
          e.classList.add('browser-default');
          if (e.querySelector('input') != null)
            e.querySelector('input').className += ' browser-default';
        }
      );
    },
  },
};
</script>

<style scoped>
#acc-levy-rates /deep/ .el-dialog {
  width: 550px !important;
}
#acc-levy-rates /deep/ .el-input{
  width: inherit;
}
</style>